import ImagingModule from "./imaging";
import AcceptInvitation from "./team/AcceptInvitation";
import {effectiveAccess,accessToLegacy,canAccess} from "./access/policy";
import {
  useState,
  useMemo,
  useEffect,
  useRef
} from "react";

import Pacientes
  from "./Pacientes";

import CalendarCitas
  from "./CalendarCitas";

import Finanzas
  from "./Finanzas";

import Dashboard
  from "./Dashboard";

import {
  onAuthStateChanged,
  signOut
} from "firebase/auth";

import {
  doc,
  getDoc,
  collection,
  onSnapshot
} from "./access/firestore";

import {
    auth,
    db,
    functions
} from "./firebase";
import {httpsCallable} from "firebase/functions";

import LoginScreen
  from "./auth/LoginScreenV2";

import {
  ClinicProvider
} from "./context/ClinicContext";

import {
  PatientProvider
} from "./PatientContext";

import {
  usePatient
} from "./PatientContext";

import {
  useClinic
} from "./context/ClinicContext";

import SettingsPanel
  from "./SettingsPanel";

import ClinicUsers
  from "./ClinicUsers";

import ActivityLogs
  from "./ActivityLogs";

import WhatsAppPanel
  from "./WhatsAppPanel";

import {
  NotificationProvider
} from "./notifications/NotificationProvider";

import {
  useNotifications
} from "./notifications/NotificationProvider";

import {
    requestPushPermission,
    listenToForegroundMessages
} from "./notifications/pushNotifications";

import MobileApp
    from "./mobile/MobileApp";

import InstallVexaDent
    from "./mobile/InstallVexaDent";

import AppUpdateNotice
    from "./components/AppUpdateNotice";

import {
  Scan,
  LayoutDashboard,
  Users,
  CalendarDays,
  Wallet,
  MessageCircle,
  UserCog,
  Settings,
  ClipboardList,
  Sparkles,
  LogOut
} from "lucide-react";

import VexaDentAI from "./VexaDentAI";
import OnboardingTour from "./onboarding/OnboardingTour";
import useMobileLayout from "./hooks/useMobileLayout";
import "./App.css";

function BillingAccessScreen({status, onCheckout, onPortal, loading}) {
  const pending = status === "pending_payment";
  const trialExpired = status === "trial_expired";
  const title = pending ? "Completa tu suscripción" : trialExpired ? "Tu prueba terminó" : "Actualiza tu método de pago";
  const message = pending ?
    "Tu cuenta está creada. Completa el pago para activar VexaDent." : trialExpired ?
      "Selecciona una modalidad de pago para continuar usando VexaDent." :
      "Tu acceso clínico está pausado hasta que se confirme un pago válido.";
  return (
    <main style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:24,background:"#f8fbff",fontFamily:"Inter,system-ui,Arial"}}>
      <section style={{width:"100%",maxWidth:500,padding:36,borderRadius:28,background:"#fff",boxShadow:"0 20px 60px rgba(15,23,42,.12)",textAlign:"center"}}>
        <img src="/vexadent-mark.png" alt="VexaDent" style={{width:82,height:82,objectFit:"contain"}} />
        <h1 style={{margin:"24px 0 12px",color:"#0f2747"}}>{title}</h1>
        <p style={{margin:"0 auto 24px",maxWidth:380,lineHeight:1.6,color:"#64748b"}}>{message}</p>
        <button onClick={pending || trialExpired ? onCheckout : onPortal} disabled={loading} style={{width:"100%",padding:14,border:0,borderRadius:14,background:"#2563eb",color:"#fff",fontWeight:700,cursor:"pointer"}}>
          {loading ? "Cargando..." : pending || trialExpired ? "Continuar al pago" : "Actualizar método de pago"}
        </button>
        <button onClick={() => signOut(auth)} style={{marginTop:14,border:0,background:"transparent",color:"#64748b",fontWeight:700,cursor:"pointer"}}>Cerrar sesión</button>
      </section>
    </main>
  );
}

function BillingNotice({clinicData, onManage}) {
  const status = clinicData?.billingStatus || "active";
  const periodEnd = clinicData?.billingCurrentPeriodEnd?.toDate?.() || new Date(clinicData?.billingCurrentPeriodEnd || 0);
  const graceEnd = clinicData?.billingGraceEndsAt?.toDate?.() || new Date(clinicData?.billingGraceEndsAt || 0);
  const daysUntilRenewal = Math.ceil((periodEnd.getTime() - Date.now()) / (24 * 60 * 60 * 1000));
  const inGrace = status === "past_due" && graceEnd.getTime() > Date.now();
  const canceling = clinicData?.billingCancelAtPeriodEnd === true;
  if (!inGrace && !canceling && (status !== "active" || daysUntilRenewal < 0 || daysUntilRenewal > 7)) return null;
  const text = inGrace ?
    "No pudimos confirmar tu pago. Tienes un periodo de gracia para actualizar tu método." : canceling ?
      `Tu suscripción termina en ${Math.max(daysUntilRenewal, 0)} días y no se renovará.` :
      `Tu suscripción se renueva en ${Math.max(daysUntilRenewal, 0)} días.`;
  return <div style={{margin:"0 0 18px",padding:"13px 16px",borderRadius:14,background:inGrace ? "#fff7ed" : "#eff6ff",border:`1px solid ${inGrace ? "#fed7aa" : "#bfdbfe"}`,color:inGrace ? "#9a3412" : "#1d4ed8",display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,fontSize:14,fontWeight:700}}><span>{text}</span>{!canceling && <button type="button" onClick={onManage} style={{border:0,borderRadius:10,padding:"8px 12px",background:"#2563eb",color:"#fff",fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>Administrar pago</button>}</div>;
}

function Sidebar({

  seccion,
  setSeccion,
  logout,
  userData

}) {

  const { setSelectedPatient } = usePatient();

  const {
    clinicData,
    clinicId,
    availableClinics,
    switchClinic
  } = useClinic();

  const [
    clinicSelectorOpen,
    setClinicSelectorOpen
  ] = useState(false);

  const [
    totalUnread,
    setTotalUnread
  ] = useState(0);

  const isConfiguredModuleEnabled = key => {
    const settings = clinicData?.settings;
    if (!settings) return true;
    if (key === "vexadent-ai") return settings.ai?.enabled !== false;
    if (key === "imagenologia") return settings.clinical?.enabledModules?.imaging !== false;
    if (key === "whatsapp") return settings.communication?.whatsappEnabled !== false;
    return true;
  };


  const navButton = (activo) => ({
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    gap: 13,
    padding: "12px 14px",
    minHeight: 46,
    borderRadius: 12,
    border: activo
      ? "1px solid rgba(45,212,191,0.28)"
      : "1px solid transparent",
    cursor: "pointer",
    textAlign: "left",
    color: activo ? "#ffffff" : "#c0d0e2",
    fontSize: 14,
    fontWeight: activo ? 700 : 500,
    background: activo
      ? "linear-gradient(100deg, rgba(20,184,166,0.24), rgba(37,99,235,0.22))"
      : "transparent",
    boxShadow: activo
      ? "inset 3px 0 0 #2dd4bf"
      : "none",
    transition: "all 180ms ease"
  });


  const modulos = [

    {
      key:"dashboard",
      label:"Panel General",
      icon:<LayoutDashboard size={20}/>,
      permiso:"dashboard"
    },

    {
      key: "vexadent-ai",
      label: "VexaDent AI",
      icon: <Sparkles size={20} />,
      permiso: "ai"
    },

    {
      key:"pacientes",
      label:"Pacientes",
      icon:<Users size={20}/>,
      permiso:"pacientes"
    },

    {
      key:"citas",
      label:"Citas",
      icon:<CalendarDays size={20}/>,
      permiso:"citas"
    },

    {key:"imagenologia",label:"Imagenología",icon:<Scan size={20}/>,permiso:"imagenologia"},

    {
      key:"finanzas",
      label:"Finanzas",
      icon:<Wallet size={20}/>,
      permiso:"finanzas"
    },

    {
      key: "whatsapp",
      label: "WhatsApp",
      icon: <MessageCircle size={20} />,
      permiso: "whatsapp"
    },

    {
      key:"usuarios",
      label:"Usuarios",
      icon:<UserCog size={20}/>,
      permiso:"usuarios"
    },

    {
      key:"settings",
      label:"Ajustes",
      icon:<Settings size={20}/>,
      permiso:"configuracion"
    },

    {
      key:"logs",
      label:"Logs",
      icon:<ClipboardList size={20}/>,
      permiso:"logs"
    },

  ];

  // =========================
  // VALIDAR SECCIÓN SEGÚN PERMISOS
  // =========================

  useEffect(() => {

    if (!userData?.permisos) {
      return;
    }

    const permisosPorSeccion = {
      dashboard: "dashboard",
      "vexadent-ai": "ai",
      pacientes: "pacientes",
      citas: "citas",
      imagenologia: "imagenologia",
      finanzas: "finanzas",
      whatsapp: "whatsapp",
      usuarios: "usuarios",
      settings: "configuracion",
      logs: "logs"
    };

    const permisoActual =
      permisosPorSeccion[seccion];

    if (
      permisoActual &&
      !userData.permisos[permisoActual]
    ) {

      const primeraSeccionDisponible = [
        "dashboard",
        "pacientes",
        "citas",
        "imagenologia",
        "finanzas",
        "whatsapp",
        "usuarios",
        "settings",
        "logs"
      ].find(
        clave =>
          userData.permisos[
            permisosPorSeccion[clave]
          ]
      );

      if (primeraSeccionDisponible) {
        setSeccion(
          primeraSeccionDisponible
        );
      }

    }

  }, [userData, seccion]);

  useEffect(() => {

    setTotalUnread(0);
    if (!clinicId || !userData?.permisos?.whatsapp) return;

    const unsubscribe =
      onSnapshot(

        collection(
          db,
          "clinics",
          clinicId,
          "whatsappConversations"
        ),

        snapshot => {

          let total = 0;

          snapshot.forEach(doc => {

            const data =
              doc.data();

            total += Number(
              data.unreadCount || 0
            );

          });

          setTotalUnread(
            total
          );

        }

      );

    return unsubscribe;

  }, [clinicId,userData?.permisos?.whatsapp]);


  const clinicName =
    clinicData?.nombreClinica ||
    "VexaDent";


  return (

    <div className="vd-sidebar">

      {/* HEADER */}

      <div
        className="vd-sidebar__header"
        style={{
          position: "relative",
          marginBottom: 22,
          paddingBottom: 18,
          borderBottom: "1px solid rgba(148,163,184,0.16)"
        }}
      >

        <button
          type="button"
          onClick={() =>
            setClinicSelectorOpen(
              prev => !prev
            )
          }
          style={{
            width:"100%",
            border:"none",
            background:"transparent",
            color:"#fff",
            padding:0,
            margin:0,
            display:"flex",
            alignItems:"center",
            gap:12,
            cursor:"pointer",
            textAlign:"left"
          }}
        >

          {clinicData?.logoURL ? (

            <img
              src={clinicData.logoURL}
              alt="logo"
              style={{
                width:50,
                height:50,
                borderRadius:14,
                objectFit:"cover",
                flexShrink:0
              }}
            />

          ) : (

            <div
              style={{
              width: "100%",
              boxSizing: "border-box",
              border: "1px solid rgba(148,163,184,0.18)",
              background: "rgba(255,255,255,0.055)",
              color: "#fff",
              padding: 12,
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: 12,
              cursor: "pointer",
              textAlign: "left",
              borderRadius: 16,
              transition: "background 180ms ease"
              }}
            >
              V
            </div>

          )}


          <div
            style={{
              minWidth:0,
              flex:1
            }}
          >

            <div
              style={{
                fontWeight:800,
                fontSize:17,
                overflow:"hidden",
                textOverflow:"ellipsis",
                whiteSpace:"nowrap"
              }}
            >
              {clinicName}
            </div>

            <div
              style={{
                fontSize:12,
                opacity:0.7,
                marginTop:2
              }}
            >
              By VexaDent
            </div>

          </div>


          {availableClinics.length > 1 && (

            <div
              style={{
                width:28,
                height:28,
                borderRadius:10,
                background:"rgba(255,255,255,0.08)",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexShrink:0,
                fontSize:14,
                transform:
                  clinicSelectorOpen
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                transition:
                  "transform .2s ease"
              }}
            >
              ▼
            </div>

          )}

        </button>


        {/* SELECTOR DE CONSULTORIOS */}

        {clinicSelectorOpen &&
          availableClinics.length > 1 && (

          <div
            style={{
              position:"absolute",
              top:62,
              left:0,
              right:0,
              background:"#ffffff",
              color:"#0f172a",
              borderRadius:16,
              padding:6,
              boxShadow:
                "0 18px 40px rgba(0,0,0,.30)",
              zIndex:1000,
              border:
                "1px solid rgba(255,255,255,.10)"
            }}
          >

            {availableClinics.map(
              clinic => {

                const name =
                  clinic?.nombreClinica ||
                  clinic?.nombre ||
                  "Consultorio";

                const isActive =
                  clinic.id === clinicId;

                return (

                  <button
                    key={clinic.id}
                    type="button"
                    onClick={async () => {

                      await switchClinic(
                        clinic.id
                      );

                      setClinicSelectorOpen(
                        false
                      );

                    }}
                    style={{
                      width:"100%",
                      border:"none",
                      borderRadius:11,
                      padding:"11px 12px",
                      background:
                        isActive
                          ? "#eff6ff"
                          : "transparent",
                      color:
                        isActive
                          ? "#2563eb"
                          : "#334155",
                      display:"flex",
                      alignItems:"center",
                      justifyContent:"space-between",
                      gap:10,
                      cursor:"pointer",
                      textAlign:"left",
                      fontSize:13.5,
                      fontWeight:
                        isActive
                          ? 700
                          : 600
                    }}
                  >

                    <span
                      style={{
                        overflow:"hidden",
                        textOverflow:"ellipsis",
                        whiteSpace:"nowrap"
                      }}
                    >
                      {name}
                    </span>

                    {isActive && (

                      <span
                        style={{
                          width:7,
                          height:7,
                          borderRadius:"50%",
                          background:"#2563eb",
                          flexShrink:0
                        }}
                      />

                    )}

                  </button>

                );

              }
            )}

          </div>

        )}

      </div>


      {/* NAV */}

      {modulos

        .filter(modulo =>

          userData?.permisos?.[
            modulo.permiso
          ]

          && isConfiguredModuleEnabled(modulo.key)

        )

        .map(modulo => (

          <button

            key={modulo.key}

            data-tour={modulo.key}

            className={`vd-sidebar__link${seccion === modulo.key ? " is-active" : ""}`}

            style={{
              ...navButton(seccion === modulo.key),
              justifyContent: "space-between",
              ...(modulo.key === "whatsapp" &&
                totalUnread > 0 &&
                seccion !== "whatsapp"
                ? {
                    background: "rgba(34,197,94,0.12)",
                    border: "1px solid rgba(34,197,94,0.20)"
                  }
                : {})
            }}

            onClick={() => {
              if (modulo.key === "pacientes") {
                setSelectedPatient(null);
              }

              setSeccion(modulo.key);
            }}

          >

            <div
              style={{
                display:"flex",
                alignItems:"center",
                gap:12,
                fontSize:15
              }}
            >

              {modulo.icon}

              <span>
                {modulo.label}
              </span>

            </div>


            {modulo.key === "whatsapp" &&
              totalUnread > 0 && (

                <div
                  style={{
                    minWidth:20,
                    height:20,
                    borderRadius:"50%",
                    background:"#22c55e",
                    color:"#fff",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    fontSize:11,
                    fontWeight:700,
                    padding:"0 6px"
                  }}
                >

                  {totalUnread > 99
                    ? "99+"
                    : totalUnread}

                </div>

              )}

          </button>

        ))}


      <div
        className="vd-sidebar__spacer"
        style={{
          flex:1
        }}
      />


      {/* USER */}

      <div
        className="vd-sidebar__profile"
        style={{
          background:
            "linear-gradient(135deg, rgba(20,184,166,0.12), rgba(37,99,235,0.10))",
          border: "1px solid rgba(148,163,184,0.16)",
          borderRadius: 16,
          padding: 15,
          marginBottom: 12,
          color: "#f8fafc",
          boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 14,
          }}
        >
          <div
            style={{
              width: 42,
              height: 42,
              minWidth: 42,
              borderRadius: 13,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background:
                "linear-gradient(135deg, #14b8a6, #2563eb)",
              color: "#ffffff",
              fontSize: 17,
              fontWeight: 800,
              boxShadow: "0 5px 14px rgba(20,184,166,0.20)",
            }}
          >
            {(userData?.nombre || "U")
              .trim()
              .charAt(0)
              .toUpperCase()}
          </div>

          <div
            style={{
              minWidth: 0,
              flex: 1,
            }}
          >
            <div
              style={{
                fontWeight: 700,
                fontSize: 15,
                lineHeight: 1.4,
                overflowWrap: "anywhere",
              }}
            >
              {userData?.nombre || "Usuario"}
            </div>

            <div
              style={{
                fontSize: 12,
                color: "#a9bdd2",
                marginTop: 3,
                overflowWrap: "anywhere",
              }}
            >
              {userData?.email}
            </div>
          </div>
        </div>

        <div
          style={{
            height: 1,
            background: "rgba(148,163,184,0.15)",
            marginBottom: 12,
          }}
        />

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              background: "rgba(20,184,166,0.14)",
              border: "1px solid rgba(45,212,191,0.20)",
              color: "#99f6e4",
              padding: "6px 10px",
              borderRadius: 999,
              fontSize: 11,
              fontWeight: 700,
              textTransform: "capitalize",
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "#2dd4bf",
              }}
            />
            {userData?.plan || "trial"}
          </div>

          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              background: "rgba(148,163,184,0.10)",
              border: "1px solid rgba(148,163,184,0.16)",
              color: "#cbd5e1",
              padding: "6px 10px",
              borderRadius: 999,
              fontSize: 11,
              fontWeight: 600,
            }}
          >
            <UserCog size={13} />
            Admin
          </div>
        </div>
      </div>

      {/* LOGOUT */}

      <div
        style={{
          marginTop: "auto",
          position: "sticky",
          bottom: 0,
          paddingTop: 16,
          paddingBottom: 4,
          background:
            "linear-gradient(180deg, rgba(11,31,56,0), #0b1f38 22%)",
        }}
      >
        <button
          onClick={logout}
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "13px 14px",
            border: "1px solid rgba(248,113,113,0.22)",
            borderRadius: 12,
            background: "rgba(248,113,113,0.08)",
            color: "#fecaca",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 13,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 11,
            transition: "all 180ms ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background =
              "rgba(248,113,113,0.16)";
            e.currentTarget.style.borderColor =
              "rgba(248,113,113,0.38)";
            e.currentTarget.style.transform =
              "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "rgba(248,113,113,0.08)";
            e.currentTarget.style.borderColor =
              "rgba(248,113,113,0.22)";
            e.currentTarget.style.transform =
              "translateY(0)";
          }}
        >
          <LogOut size={17} />
          Cerrar sesión
        </button>
      </div>

    </div>

  );

}

function MainApp({ isMobile }) {

  const [
    seccion,
    setSeccion
  ] = useState(
    "dashboard"
  );

  const [
    fechaAgendaInicial,
    setFechaAgendaInicial
  ] = useState(null);

  const abrirCitaEnAgenda = (cita) => {

    if (
      !cita?.fecha ||
      !userData?.permisos?.citas
    ) {
      return;
    }

    setFechaAgendaInicial(
      cita.fecha
    );

    setSeccion("citas");

  };

  // =========================
  // AUTH
  // =========================

  const [
    user,
    setUser
  ] = useState(null);

  const [
    globalUserData,
    setUserData
  ] = useState(null);

  const [billingLoading, setBillingLoading] = useState(false);

  const [
    notificationsReady,
    setNotificationsReady
  ] = useState(false);

  const [
    notifiedMessages,
    setNotifiedMessages
  ] = useState({});

    const [
    pendingAction,
    setPendingAction
  ] = useState(null);

  const {
    notify
  } = useNotifications();

  useEffect(() => {
    const handleUnhandledRejection = event => {
      const reason = event.reason;
      const message = reason?.message || String(reason ?? "Error desconocido");
      alert(`PROMESA:\n\n${message}`);
    };

    const handleWindowError = event => {
      if (event.message) {
        alert(`EVENT ERROR:\n\n${event.message}`);
      }
    };

    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    window.addEventListener("error", handleWindowError);

    return () => {
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
      window.removeEventListener("error", handleWindowError);
    };
  }, []);

  const {
    clinicData,
    clinicId: activeClinicId,
    availableClinics,
    switchClinic
  } = useClinic();
  const {currentUser:clinicMember,loading:clinicLoading,error:clinicError,refreshClinic}=useClinic();

  const isConfiguredModuleEnabled = key => {
    const settings = clinicData?.settings;
    if (!settings) return true;
    if (key === "vexadent-ai") return settings.ai?.enabled !== false;
    if (key === "imagenologia") return settings.clinical?.enabledModules?.imaging !== false;
    if (key === "whatsapp") return settings.communication?.whatsappEnabled !== false;
    return true;
  };
  const userData=useMemo(()=>(globalUserData||clinicMember)?{...globalUserData,...clinicMember,clinicId:activeClinicId,permisos:accessToLegacy(effectiveAccess(clinicMember))}:null,[globalUserData,clinicMember,activeClinicId]);


  const {
    setSelectedPatient
  } = usePatient();

  // =========================
  // NOTIFICACIONES WHATSAPP
  // =========================

  const notifiedMessagesRef =
    useRef({});

  const initializedClinicsRef =
    useRef({});

  const previousUnreadCountsRef =
    useRef({});

  useEffect(() => {

    if (
      !userData?.clinicId ||
      !userData?.permisos?.whatsapp ||
      !canAccess(clinicMember,"notifications") ||
      window.Notification?.permission !==
        "granted"
    ) {
      return;
    }

    const clinicIds = [userData.clinicId];

    const unsubscribes =
      clinicIds.map(
        clinicId => {

          return onSnapshot(

            collection(
              db,
              "clinics",
              clinicId,
              "whatsappConversations"
            ),

            snapshot => {

              if (
                !initializedClinicsRef
                  .current[clinicId]
              ) {

                snapshot.forEach(
                  conversationDoc => {

                    const data =
                      conversationDoc.data();

                    const key =
                      `${clinicId}:${conversationDoc.id}`;

                    notifiedMessagesRef
                      .current[key] =
                        data.lastMessageAt
                          ?.seconds || 0;

                    previousUnreadCountsRef
                      .current[key] =
                        data.unreadCount || 0;

                  }
                );

                initializedClinicsRef
                  .current[clinicId] =
                    true;

                return;

              }

              snapshot.docChanges()
                .forEach(
                  change => {

                    if (
                      change.type !==
                        "modified" &&
                      change.type !==
                        "added"
                    ) {

                      return;

                    }

                    const data =
                      change.doc.data();

                    const key =
                      `${clinicId}:${change.doc.id}`;

                    const timestamp =
                      data.lastMessageAt
                        ?.seconds || 0;
                    
                    const previousUnreadCount =
                      previousUnreadCountsRef
                        .current[key] || 0;

                    const currentUnreadCount =
                      data.unreadCount || 0;

                    previousUnreadCountsRef
                      .current[key] =
                        currentUnreadCount;

                    if (
                      notifiedMessagesRef
                        .current[key] ===
                      timestamp
                    ) {

                      return;

                    }

                    notifiedMessagesRef
                      .current[key] =
                        timestamp;

                    if (
                      currentUnreadCount >
                      previousUnreadCount
                    ) {

                      const originClinic =
                        availableClinics?.find(
                          clinic =>
                            clinic.id ===
                            clinicId
                        );

                      const notificationData = {

                        type:
                          "whatsapp",

                        title:
                          data.patientName ||
                          "Nuevo mensaje",

                        message:
                          data.lastMessage ||
                          "Nuevo mensaje recibido.",

                        clinicName:
                          originClinic
                            ?.nombreClinica ||
                          "VexaDent",

                        clinicLogo:
                          originClinic
                            ?.logoURL ||
                          null,

                        onOpenConversation:
                          async () => {

                            if (
                              activeClinicId !==
                              clinicId
                            ) {

                              await switchClinic(
                                clinicId
                              );

                            }

                            setSeccion(
                              "whatsapp"
                            );

                            setPendingAction({

                              type:
                                "conversation",

                              conversationId:
                                change.doc.id

                            });

                          },

                        onOpenPatient:
                          async () => {

                            if (
                              !data.patientId ||
                              !userData?.permisos?.pacientes
                            ) {

                              return;

                            }

                            if (
                              activeClinicId !==
                              clinicId
                            ) {

                              await switchClinic(
                                clinicId
                              );

                            }

                            setSelectedPatient({

                              id:
                                data.patientId

                            });

                            setSeccion(
                              "pacientes"
                            );

                          }

                      };

                      if (
                        document.visibilityState ===
                        "visible"
                      ) {

                        notify(
                          notificationData
                        );

                      } else {

                        if (
                          !window.Notification
                        ) {

                          return;

                        }

                        const nativeNotification =
                          new window.Notification(

                            notificationData.title,

                            {

                              body:
                                notificationData.message,

                              icon:
                                notificationData
                                  .clinicLogo ||
                                "/logo192.png",

                              tag:
                                key,

                              requireInteraction:
                                true

                            }

                          );

                        nativeNotification.onclick =
                          () => {

                            window.focus();

                            setTimeout(
                              () => {

                                notificationData
                                  .onOpenConversation();

                              },
                              150
                            );

                            nativeNotification
                              .close();

                          };

                      }

                    }

                  }

                );

            }

          );

        }
      );

    return () => {

      unsubscribes.forEach(
        unsubscribe =>
          unsubscribe()
      );

    };

  }, [

    userData,

    clinicMember,

    activeClinicId,

    availableClinics,

    switchClinic,

    notify

  ]);

  const [
      loadingAuth,
      setLoadingAuth
  ] = useState(true);

  const [
      splashFinished,
      setSplashFinished
  ] = useState(false);

  useEffect(() => {

      const timer = setTimeout(() => {

          setSplashFinished(true);

      }, 3000);

      return () => {

          clearTimeout(timer);

      };

  }, []);

  useEffect(() => {

      const style =
          document.createElement("style");

      style.innerHTML = `

          @keyframes vexadentLogoReveal {

              0% {
                  opacity: 0;
                  transform:
                      scale(0.72)
                      rotate(-8deg);
              }

              55% {
                  opacity: 1;
                  transform:
                      scale(1.06)
                      rotate(2deg);
              }

              100% {
                  opacity: 1;
                  transform:
                      scale(1)
                      rotate(0deg);
              }

          }

          @keyframes vexadentLogoFloat {

              0% {
                  transform:
                      translateY(0);
              }

              50% {
                  transform:
                      translateY(-7px);
              }

              100% {
                  transform:
                      translateY(0);
              }

          }

          @keyframes vexadentGlow {

              0% {
                  filter:
                      drop-shadow(
                          0 0 0
                          rgba(37,99,235,0)
                      );
              }

              50% {
                  filter:
                      drop-shadow(
                          0 0 30px
                          rgba(37,99,235,0.32)
                      );
              }

              100% {
                  filter:
                      drop-shadow(
                          0 0 0
                          rgba(37,99,235,0)
                      );
              }

          }

          @keyframes vexadentNameReveal {

              0% {
                  opacity: 0;

                  transform:
                      translateY(14px);

                  letter-spacing:
                      0.28em;
              }

              100% {
                  opacity: 1;

                  transform:
                      translateY(0);

                  letter-spacing:
                      -0.02em;
              }

          }

          @keyframes vexadentSubtitleReveal {

              0% {
                  opacity: 0;

                  transform:
                      translateY(10px);
              }

              100% {
                  opacity: 1;

                  transform:
                      translateY(0);
              }

          }

          @keyframes vexadentLineReveal {

              0% {
                  width: 0;
                  opacity: 0;
              }

              100% {
                  width: 150px;
                  opacity: 1;
              }

          }

          @keyframes vexadentLoadingPulse {

              0% {
                  opacity: 0.35;
              }

              50% {
                  opacity: 1;
              }

              100% {
                  opacity: 0.35;
              }

          }

          @keyframes vexadentLoadingDots {

              0% {
                  opacity: 0.25;
              }

              50% {
                  opacity: 1;
              }

              100% {
                  opacity: 0.25;
              }

          }

      `;

      document.head.appendChild(
          style
      );

      return () => {

          document.head.removeChild(
              style
          );

      };

  }, []);

  const verificationPath =
      window.location.pathname.match(
          /^\/verificar-receta\/([^/]+)$/
      );

  const verificationPrescriptionId =
      verificationPath?.[1] || null;

  // =========================
  // ESCUCHAR SESIÓN
  // =========================

  useEffect(() => {

    const unsubscribe =
      onAuthStateChanged(

        auth,

        async currentUser => {

          // SIN SESIÓN

          if (!currentUser) {

            setUser(null);

            setUserData(null);

            setLoadingAuth(false);

            return;
          }

          // SESIÓN ACTIVA

          setUser(currentUser);

          listenToForegroundMessages((payload) => {
              console.log(
                  "VEXADENT PUSH FOREGROUND:",
                  payload
              );
          });

          // =====================================================
          // REGISTRO DEL DISPOSITIVO PARA PUSH
          // =====================================================

          requestPushPermission()
              .then(token => {

                  if (token) {

                      console.log(
                          "VEXADENT PUSH TOKEN REGISTRADO:",
                          token
                      );

                  }

              })
              .catch(error => {

                  console.error(
                      "Error registrando Push de VexaDent:",
                      error
                  );

              });


          try {

              const userRef =
                  doc(
                      db,
                      "users",
                      currentUser.uid
                  );

              const userSnap =
                  await getDoc(userRef);

              if (userSnap.exists()) {

                  const data = userSnap.data();

                  setUserData({
                    ...data,
                    permisos: {
                      ...data.permisos,
                      whatsapp: data.permisos?.whatsapp === true
                    }
                  });
              }

          } catch (err) {

              console.error(err);
          }

          setLoadingAuth(false);
        }
      );

    return unsubscribe;

  }, []);

  // =========================
  // PERMISOS DE NOTIFICACIONES
  // =========================

  useEffect(() => {

    if (!("Notification" in window)) {

      console.log(
        "Este navegador no soporta notificaciones."
      );

      return;

    }

    if (

      window.Notification?.permission ===
      "default"

    ) {

      window.Notification?.requestPermission()

        .then(permission => {

          console.log(
            "PERMISO NOTIFICACIONES:",
            permission
          );

        });

    }

  }, []);

  // =========================
  // LOADING
  // =========================

  if (
      loadingAuth ||
      !splashFinished
  ) {

      return (

          <div
              style={{
                  position:"fixed",
                  inset:0,
                  zIndex:99999,
                  background:"#ffffff",
                  display:"flex",
                  flexDirection:"column",
                  alignItems:"center",
                  justifyContent:"center",
                  fontFamily:"Inter, system-ui, Arial",
                  overflow:"hidden"
              }}
          >

              <div
                  style={{
                      display:"flex",
                      flexDirection:"column",
                      alignItems:"center",
                      justifyContent:"center",
                      transform:"translateY(-12px)"
                  }}
              >

                  <div
                      style={{
                          position:"relative",
                          width:150,
                          height:150,
                          display:"flex",
                          alignItems:"center",
                          justifyContent:"center",
                          animation:
                              "vexadentLogoReveal 1.15s cubic-bezier(.22,1,.36,1) both, vexadentLogoFloat 3.8s ease-in-out 1.15s infinite, vexadentGlow 2.8s ease-in-out 1.15s infinite"
                      }}
                  >

                      <div
                          style={{
                              position:"absolute",
                              width:118,
                              height:118,
                              borderRadius:"50%",
                              background:
                                  "radial-gradient(circle, rgba(37,99,235,0.16) 0%, rgba(20,184,166,0.10) 42%, rgba(255,255,255,0) 72%)",
                              filter:"blur(12px)"
                          }}
                      />

                      <img
                          src="/vexadent-mark.png"
                          alt="VexaDent"
                          style={{
                              position:"relative",
                              width:128,
                              height:128,
                              objectFit:"contain",
                              display:"block"
                          }}
                      />

                  </div>

                  <div
                      style={{
                          marginTop:24,
                          fontSize:42,
                          lineHeight:1,
                          fontWeight:800,
                          color:"#0f2747",
                          animation:
                              "vexadentNameReveal 0.9s cubic-bezier(.22,1,.36,1) 0.45s both",
                          whiteSpace:"nowrap"
                      }}
                  >

                      <span
                          style={{
                              color:"#123b6d"
                          }}
                      >
                          Vexa
                      </span>

                      <span
                          style={{
                              color:"#18b8b5"
                          }}
                      >
                          Dent
                      </span>

                  </div>

                  <div
                      style={{
                          marginTop:12,
                          fontSize:11,
                          fontWeight:600,
                          letterSpacing:"0.22em",
                          color:"#64748b",
                          textAlign:"center",
                          animation:
                              "vexadentSubtitleReveal 0.8s ease-out 0.9s both",
                          whiteSpace:"nowrap"
                      }}
                  >
                      GESTIÓN DENTAL INTELIGENTE
                  </div>

                  <div
                      style={{
                          marginTop:18,
                          height:2,
                          borderRadius:999,
                          background:
                              "linear-gradient(90deg, #2563eb, #14b8a6)",
                          animation:
                              "vexadentLineReveal 0.9s cubic-bezier(.22,1,.36,1) 1.15s both"
                      }}
                  />

                  <div
                      style={{
                          marginTop:18,
                          display:"flex",
                          alignItems:"center",
                          gap:5,
                          fontSize:10,
                          fontWeight:600,
                          letterSpacing:"0.18em",
                          color:"#94a3b8",
                          animation:
                              "vexadentLoadingPulse 1.6s ease-in-out infinite",
                          whiteSpace:"nowrap"
                      }}
                  >

                      <span>
                          CARGANDO VEXADENT
                      </span>

                      <span
                          style={{
                              display:"inline-flex",
                              gap:3
                          }}
                      >

                          <span
                              style={{
                                  animation:
                                      "vexadentLoadingDots 1.2s ease-in-out infinite"
                              }}
                          >
                              •
                          </span>

                          <span
                              style={{
                                  animation:
                                      "vexadentLoadingDots 1.2s ease-in-out 0.2s infinite"
                              }}
                          >
                              •
                          </span>

                          <span
                              style={{
                                  animation:
                                      "vexadentLoadingDots 1.2s ease-in-out 0.4s infinite"
                              }}
                          >
                              •
                          </span>

                      </span>

                  </div>

              </div>

          </div>

      );

  }

  // =========================
  // VERIFICACIÓN PÚBLICA DE RECETA
  // =========================

  if (verificationPrescriptionId) {

    return (
      <PublicPrescriptionVerification />
    );
  }

  // =========================
  // SIN LOGIN
  // =========================

  if (!user) {

    return <LoginScreen />;
  }

  // =========================
  // SIN CLÍNICA
  // =========================

  if(!clinicLoading && (!activeClinicId || !clinicMember))return <main style={{maxWidth:540,margin:"15vh auto",padding:24}}><h1>Acceso al consultorio</h1><p>{clinicError||"Tu cuenta no tiene acceso activo a un consultorio. Solicita una invitación a su administrador."}</p><button onClick={refreshClinic}>Actualizar acceso</button> <button onClick={()=>signOut(auth)}>Cerrar sesión</button></main>;

  if (
      !userData?.clinicId ||
      !clinicData
  ) {

      return (

          <div
              style={{
                  minHeight:"100vh",
                  background:"#ffffff",
                  display:"flex",
                  flexDirection:"column",
                  alignItems:"center",
                  justifyContent:"center",
                  fontFamily:"Inter, system-ui, Arial"
              }}
          >

              <img
                  src="/vexadent-mark.png"
                  alt="VexaDent"
                  style={{
                      width:128,
                      height:128,
                      objectFit:"contain",
                      display:"block"
                  }}
              />

              <div
                  style={{
                      marginTop:24,
                      fontSize:42,
                      lineHeight:1,
                      fontWeight:800,
                      letterSpacing:"-0.02em",
                      whiteSpace:"nowrap"
                  }}
              >

                  <span
                      style={{
                          color:"#123b6d"
                      }}
                  >
                      Vexa
                  </span>

                  <span
                      style={{
                          color:"#18b8b5"
                      }}
                  >
                      Dent
                  </span>

              </div>

              <div
                  style={{
                      marginTop:12,
                      fontSize:11,
                      fontWeight:600,
                      letterSpacing:"0.22em",
                      color:"#64748b",
                      textTransform:"uppercase"
                  }}
              >
                  GESTIÓN DENTAL INTELIGENTE
              </div>

          </div>

      );

  }

  const billingStatus =
    clinicData?.billingStatus ||
    userData?.billingStatus ||
    userData?.subscriptionStatus ||
    "active";

  const startBillingCheckout = async () => {
    try {
      setBillingLoading(true);
      const result = await httpsCallable(
          functions,
          "createStripeCheckoutSession",
      )({
        plan: "standard",
        interval: clinicData?.billingInterval === "year" ? "year" : "month",
      });
      if (result.data?.url) window.location.assign(result.data.url);
    } catch (error) {
      alert(error.message || "No fue posible abrir el pago.");
    } finally {
      setBillingLoading(false);
    }
  };

  const openBillingPortal = async () => {
    try {
      setBillingLoading(true);
      const result = await httpsCallable(
          functions,
          "createStripeBillingPortal",
      )({});
      if (result.data?.url) window.location.assign(result.data.url);
    } catch (error) {
      alert(error.message || "No fue posible abrir facturación.");
    } finally {
      setBillingLoading(false);
    }
  };

  if (["pending_payment", "past_due", "canceled"].includes(billingStatus)) {
    const graceEndsAt = clinicData?.billingGraceEndsAt?.toDate?.() || new Date(clinicData?.billingGraceEndsAt || 0);
    const periodEnd = clinicData?.billingCurrentPeriodEnd?.toDate?.() || new Date(clinicData?.billingCurrentPeriodEnd || 0);
    const stillInGrace = billingStatus === "past_due" && graceEndsAt.getTime() > Date.now();
    const canceledButPaid = billingStatus === "canceled" && periodEnd.getTime() > Date.now();
    if (!stillInGrace && !canceledButPaid) {
      return <BillingAccessScreen status={billingStatus} onCheckout={startBillingCheckout} onPortal={openBillingPortal} loading={billingLoading} />;
    }
  }

  const trialEndsAt = clinicData?.billingTrialEndsAt?.toDate?.() || new Date(clinicData?.billingTrialEndsAt || 0);
  if (billingStatus === "trial" && trialEndsAt.getTime() <= Date.now()) {
    return <BillingAccessScreen status="trial_expired" onCheckout={startBillingCheckout} onPortal={openBillingPortal} loading={billingLoading} />;
  }

  // =========================
  // LOGOUT
  // =========================

  const logout = async () => {

    try {

      await signOut(auth);

    } catch (err) {

      console.error(err);
    }
  };

  // =========================
  // ESTILOS
  // =========================

  console.log({
      innerWidth: window.innerWidth,
      outerWidth: window.outerWidth,
      screenWidth: window.screen.width,
      isMobile
  });

  if(!Object.values(userData?.permisos||{}).some(Boolean))return <main style={{maxWidth:560,margin:"15vh auto",padding:24}}><h1>Tu cuenta ya está activa</h1><p>{clinicData?.nombre||clinicData?.nombreClinica||"El consultorio"} todavía no te ha asignado módulos. Solicita a su administrador que configure tus permisos.</p><button onClick={refreshClinic}>Actualizar permisos</button> <button onClick={logout}>Cerrar sesión</button></main>;

  if (isMobile) {

      return (

          <>

          <AppUpdateNotice />

          <MobileApp
              key={activeClinicId}

              userData={userData}

              onboardingUser={user}

              clinicData={
                  clinicData
              }

              logout={
                  logout
              }

          />

          </>

      );

  }

  // =========================
  // RENDER
  // =========================

  return (

      <>

      <AppUpdateNotice />

      <div className="vd-app-shell">

        <Sidebar

          seccion={seccion}

          setSeccion={setSeccion}

          logout={logout}

          userData={userData}

        />

        {/* CONTENIDO */}

        <div className="vd-app-content">

          <BillingNotice clinicData={clinicData} onManage={openBillingPortal} />

          {seccion === "dashboard" &&
          userData?.permisos?.dashboard && (

              <Dashboard />

          )}

          {seccion === "vexadent-ai" &&
          userData?.permisos?.ai &&
          isConfiguredModuleEnabled("vexadent-ai") && (
            <VexaDentAI />
          )}

          {seccion === "pacientes" &&
          userData?.permisos?.pacientes && (

            <Pacientes
              onIrACita={abrirCitaEnAgenda}
            />

          )}

          {seccion === "citas" &&
          userData?.permisos?.citas && (

            <CalendarCitas
              fechaInicial={
                fechaAgendaInicial
              }
            />

          )}

          {seccion === "imagenologia" && userData?.permisos?.imagenologia && isConfiguredModuleEnabled("imagenologia") && <ImagingModule key={activeClinicId}/> }

          {seccion === "finanzas" &&
          userData?.permisos?.finanzas && (

            <Finanzas />

          )}

          {seccion === "usuarios" &&
          userData?.permisos?.usuarios && (

            <ClinicUsers />

          )}

          {seccion === "settings" &&
          userData?.permisos?.configuracion && (

            <SettingsPanel />

          )}

          {seccion === "logs" &&
          userData?.permisos?.logs && (

            <ActivityLogs />

          )}

          {seccion === "whatsapp" &&
          userData?.permisos?.whatsapp &&
          isConfiguredModuleEnabled("whatsapp") && (

            <WhatsAppPanel
              setSeccion={setSeccion}

              pendingAction={
                pendingAction
              }

              setPendingAction={
                setPendingAction
              }
            />

          )}

        </div>

        <OnboardingTour
          user={user}
          clinicId={activeClinicId}
          userData={userData}
          isMobile={false}
          currentSection={seccion}
          onNavigate={setSeccion}
        />

            </div>

      </>

  );
}

function PublicPrescriptionVerification() {

  const [verification, setVerification] =
    useState(null);

  const [loadingVerification, setLoadingVerification] =
    useState(true);

  useEffect(() => {

    const loadVerification = async () => {

      try {

        const verificationPath =
          window.location.pathname.match(
            /^\/verificar-receta\/([^/]+)$/
          );

        const prescriptionId =
          verificationPath?.[1] || null;

        if (!prescriptionId) {
          setVerification(null);
          setLoadingVerification(false);
          return;
        }

        const verificationRef =
          doc(
            db,
            "prescriptionVerifications",
            prescriptionId
          );

        const verificationSnap =
          await getDoc(verificationRef);

        if (verificationSnap.exists()) {

          setVerification(
            verificationSnap.data()
          );

        } else {

          setVerification(null);

        }

      } catch (error) {

        console.error(
          "Error verificando receta:",
          error
        );

        setVerification(null);

      } finally {

        setLoadingVerification(false);

      }

    };

    loadVerification();

  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f3f4f6",
        padding: "24px 16px",
        fontFamily: "Inter, system-ui, Arial"
      }}
    >

      <div
        style={{
          width: "100%",
          maxWidth: "620px",
          margin: "0 auto",
          background: "#ffffff",
          borderRadius: "20px",
          padding: "32px",
          boxShadow:
            "0 10px 30px rgba(0,0,0,0.08)"
        }}
      >

        {loadingVerification && (

          <div
            style={{
              textAlign: "center",
              padding: "40px 0"
            }}
          >
            <div
              style={{
                fontSize: "24px",
                fontWeight: 700
              }}
            >
              Verificación de receta
            </div>

            <p
              style={{
                color: "#6b7280"
              }}
            >
              Verificando receta...
            </p>

          </div>

        )}

        {!loadingVerification &&
          !verification && (

          <div
            style={{
              textAlign: "center",
              padding: "40px 0"
            }}
          >

            <div
              style={{
                fontSize: "24px",
                fontWeight: 700,
                marginBottom: "12px"
              }}
            >
              Verificación de receta
            </div>

            <div
              style={{
                padding: "16px",
                borderRadius: "12px",
                background: "#fef2f2",
                color: "#991b1b"
              }}
            >
              No se encontró una receta válida
              para este código de verificación.
            </div>

          </div>

        )}

        {!loadingVerification &&
          verification && (

          <div>

            {/* LOGO DEL CONSULTORIO */}

            {verification.clinicLogoURL && (

              <div
                style={{
                  textAlign: "center",
                  marginBottom: "16px"
                }}
              >

                <img
                  src={verification.clinicLogoURL}
                  alt="Logo del consultorio"
                  style={{
                    maxWidth: "180px",
                    maxHeight: "90px",
                    objectFit: "contain"
                  }}
                />

              </div>

            )}

            {/* CONSULTORIO */}

            <div
              style={{
                textAlign: "center",
                marginBottom: "24px"
              }}
            >

              <div
                style={{
                  fontSize: "24px",
                  fontWeight: 700,
                  color: "#111827"
                }}
              >
                {verification.clinicName ||
                  "Consultorio dental"}
              </div>

              {verification.clinicAddress && (

                <div
                  style={{
                    marginTop: "8px",
                    color: "#6b7280",
                    fontSize: "14px",
                    lineHeight: 1.5
                  }}
                >
                  {typeof verification.clinicAddress === "object"
                    ? [
                        verification.clinicAddress.calle,
                        verification.clinicAddress.numeroExterior
                          ? `No. ${verification.clinicAddress.numeroExterior}`
                          : null,
                        verification.clinicAddress.numeroInterior
                          ? `Int. ${verification.clinicAddress.numeroInterior}`
                          : null,
                        verification.clinicAddress.colonia,
                        verification.clinicAddress.ciudad,
                        verification.clinicAddress.estado,
                        verification.clinicAddress.codigoPostal
                          ? `C.P. ${verification.clinicAddress.codigoPostal}`
                          : null
                      ]
                        .filter(Boolean)
                        .join(", ")
                    : verification.clinicAddress}
                </div>

              )}

              {verification.clinicPhone && (

                <div
                  style={{
                    marginTop: "4px",
                    color: "#6b7280",
                    fontSize: "14px"
                  }}
                >
                  Tel. {verification.clinicPhone}
                </div>

              )}

            </div>

            {/* ESTADO */}

            <div
              style={{
                marginBottom: "24px",
                padding: "14px",
                borderRadius: "12px",
                background: "#ecfdf5",
                color: "#065f46",
                textAlign: "center",
                fontWeight: 600
              }}
            >
              ✓ Receta verificada
            </div>

            {/* PROFESIONAL */}

            <div
              style={{
                padding: "20px",
                borderRadius: "14px",
                background: "#f9fafb",
                border: "1px solid #e5e7eb"
              }}
            >

              <div
                style={{
                  fontSize: "18px",
                  fontWeight: 700,
                  marginBottom: "16px"
                }}
              >
                Profesional emisor
              </div>

              <div>

                <strong>Nombre</strong>

                <div
                  style={{
                    marginTop: "4px"
                  }}
                >
                  {verification.doctorName ||
                    "No registrado"}
                </div>

              </div>

              {verification.puesto && (

                <div
                  style={{
                    marginTop: "14px"
                  }}
                >

                  <strong>Puesto</strong>

                  <div
                    style={{
                      marginTop: "4px"
                    }}
                  >
                    {verification.puesto}
                  </div>

                </div>

              )}

              <div
                style={{
                  marginTop: "14px"
                }}
              >

                <strong>Especialidad</strong>

                <div
                  style={{
                    marginTop: "4px"
                  }}
                >
                  {verification.especialidad ||
                    "No registrada"}
                </div>

              </div>

              <div
                style={{
                  marginTop: "14px"
                }}
              >

                <strong>Cédula profesional</strong>

                <div
                  style={{
                    marginTop: "4px"
                  }}
                >
                  {verification.cedula ||
                    "No registrada"}
                </div>

              </div>

              <div
                style={{
                  marginTop: "14px"
                }}
              >

                <strong>Universidad</strong>

                <div
                  style={{
                    marginTop: "4px"
                  }}
                >
                  {verification.universidad ||
                    "No registrada"}
                </div>

              </div>

              {/* LOGO UNIVERSIDAD */}

              {verification.universidadLogoURL && (

                <div
                  style={{
                    marginTop: "16px",
                    textAlign: "center"
                  }}
                >

                  <img
                    src={verification.universidadLogoURL}
                    alt="Logo de la universidad"
                    style={{
                      maxWidth: "180px",
                      maxHeight: "80px",
                      objectFit: "contain"
                    }}
                  />

                </div>

              )}

            </div>

            {/* FECHA */}

            <div
              style={{
                marginTop: "20px",
                paddingTop: "16px",
                borderTop: "1px solid #e5e7eb",
                textAlign: "center",
                color: "#6b7280",
                fontSize: "13px"
              }}
            >

              Fecha de emisión

              <div
                style={{
                  marginTop: "4px",
                  color: "#374151",
                  fontWeight: 500
                }}
              >
                {verification.createdAtText ||
                  "No registrada"}
              </div>

            </div>

            {/* IDENTIFICADOR */}

            <div
              style={{
                marginTop: "20px",
                textAlign: "center",
                fontSize: "11px",
                color: "#9ca3af",
                wordBreak: "break-all"
              }}
            >
              Folio de verificación:
              <br />
              {verification.prescriptionId}
            </div>

            <div
              style={{
                marginTop: "24px",
                textAlign: "center",
                fontSize: "12px",
                color: "#9ca3af"
              }}
            >
              Verificación electrónica mediante VexaDent
            </div>

          </div>

        )}

      </div>

    </div>
  );
}

export default function App() {

  const { isMobile, isMobileDevice, isStandalone } = useMobileLayout();

  const isInvitationRoute = window.location.pathname === "/invitacion";

  const isVerificationRoute =
    /^\/verificar-receta\/[^/]+$/.test(
      window.location.pathname
    );


  if (
    isMobile &&
    isMobileDevice &&
    !isStandalone &&
    !isVerificationRoute &&
    !isInvitationRoute &&
    process.env.NODE_ENV !== "development"
  ) {

    return (
      <InstallVexaDent />
    );

  }


  if(isInvitationRoute)return <AcceptInvitation/>;

  return (

    <ClinicProvider>

      <PatientProvider>

        <NotificationProvider>

          <MainApp isMobile={isMobile} />

        </NotificationProvider>

      </PatientProvider>

    </ClinicProvider>

  );

}
